import styled from "styled-components";

export const ActiveCampaignWrapper = styled.div`
    .page-title {
        font-size: 26px;
    }

    .top-panel {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 30px;

        .top-panel-title {
            font-size: 20px;
            font-weight: 700;
        }

        .top-panel-inside {
            display: flex;
            gap: 30px;
        }

        .total-num {
            color: rgba(55, 54, 71, 0.6);
            font-weight: 400;
            margin-inline-start: 5px;
        }
    }

    .report-top {
        margin-bottom: 0;
    }

    .scroll-track {
        width: 7px !important;
        background: #fff !important;
    }
    .scroll-thumb {
    background: linear-gradient(179.97deg, #6D8FFF -24.96%, #8467FF 99.97%) !important;
    border-radius: 25px !important;
    }

    .ScrollbarsCustom-Wrapper {
        margin-right: 18px;
    }

    .no_records {
        margin-top: 30px;
        text-align: center;
        font-size: 20px;
    }
`

export const ActiveCampaignTabs = styled.div`
  width: 400px;

  &.active-selected {
    .react-switch-selector-wrapper::before {
      left: 2px;
    }
  }

  .react-switch-selector-wrapper {
    direction: ltr;
    font-size: 14px;
    line-height: 22px;
    font-weight: bold;
    border-radius: 50px;
    height: auto;

    &::before {
        height: calc(100% - 3px);
        width: calc(50% - 2px);
      }

    label {
      margin: 0;
    }
  }

  .react-switch-selector-option {
    padding: 9px 20px;
  }
`;

export const StyledAptCard = styled.div`
    background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
    box-shadow: 0px 3px 34px rgba(89, 102, 137, 0.05);
    border-radius: 25px;
    padding: 15px 30px;
    margin-top: 20px;
    width: 100%;
    direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'};

    .first-row {
        border-bottom: 1px solid rgba(216, 210, 255, 0.5);
        margin-bottom: 10px;
        padding-bottom: 10px;     
    }
    
    .second-row, .first-row {
        display: flex;
        gap: 60px;
    }

    .apartment-info-inner-wrapper {
        display: flex;
        flex-direction: column;
        gap: 8px;
        font-size: 16px;
        
        .header {
            font-weight: 700;
            color: rgba(55, 54, 71, 0.7);
            text-align: start;
        }
        .value {
            color: rgba(55, 54, 71, 0.7);
            text-align: start;
        }
    }
    
    .buttons-wrapper {
        margin-top: 17px;
        display: flex;
        justify-content: flex-start;
        gap: 50px;
    }
`